import { Tree, TreeProps } from 'antd';
import { IProps } from '@components/data-display/tree/types';
import { FC } from 'react';

export const ILSTree: FC<TreeProps & IProps> = (props) => {
  return <Tree {...props} />;
};
